import { useSyncExternalStore } from "react";

export const useIsTouchDevice = () => {
    const subscribe = (callback: () => void) => {
        const mediaQueryList = window.matchMedia("(pointer: coarse)");
        mediaQueryList.addEventListener("change", callback);

        return () => {
            mediaQueryList.removeEventListener("change", callback);
        };
    };

    const getSnapshot = () => window.matchMedia("(pointer: coarse)").matches;

    return useSyncExternalStore(subscribe, getSnapshot);
};
